import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import Button from '../../components/Button';
import Badge from '../../components/Badge';
import { useAuth } from '../../contexts/AuthContext';

export default function AdminUsers() {
  const { isSuperAdmin } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get('/api/admin/users').then((r) => setUsers(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const updateRole = async (id, role) => { await api.put(`/api/admin/users/${id}`, { role }); load(); };
  const toggleActive = async (id, is_active) => { await api.put(`/api/admin/users/${id}`, { is_active }); load(); };
  const deleteUser = async (id) => { if (!window.confirm('Benutzer wirklich löschen?')) return; await api.delete(`/api/admin/users/${id}`); load(); };

  return (
    <div>
      <h2 className="page-title">Benutzerverwaltung</h2>
      {loading ? <div className="flex justify-center py-8"><div className="animate-spin rounded-full h-7 w-7 border-2 border-ocean-400 border-t-transparent"/></div> : (
        <div className="space-y-3">
          {users.map((u) => (
            <div key={u.id} className="card flex flex-wrap justify-between items-center gap-3">
              <div>
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="font-bold text-ocean-900">{u.username}</span>
                  <Badge status={u.role} />
                  {!u.is_active && <Badge status="cancelled" custom="Inaktiv" />}
                </div>
                <p className="text-xs text-slate-500">{u.firstname} {u.lastname} · {u.email}</p>
                {u.nickname && <p className="text-xs text-slate-400">Nickname: {u.nickname}</p>}
              </div>
              {isSuperAdmin && (
                <div className="flex gap-2 flex-wrap items-center">
                  <select className="input text-xs w-auto"
                    value={u.role} onChange={(e) => updateRole(u.id, e.target.value)}>
                    {['user','participant','tournament_admin','admin','superadmin'].map((r) => <option key={r} value={r}>{r}</option>)}
                  </select>
                  <Button variant="ghost" size="sm" onClick={() => toggleActive(u.id, !u.is_active)}>
                    {u.is_active ? 'Deaktivieren' : 'Aktivieren'}
                  </Button>
                  <Button variant="danger" size="sm" onClick={() => deleteUser(u.id)}>Löschen</Button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
